import {ChangeDetectionStrategy, Component} from '@angular/core';
import {PageTitleComponent} from "../../../components/page-title/page-title.component";
import {PageSubtitleComponent} from "../../../components/page-subtitle/page-subtitle.component";
import {TextPageComponent} from "../../../components/text-page/text-page.component";
import {HomeyH3Component} from "../../../components/homey-h3/homey-h3.component";
import {HomeyH4Component} from "../../../components/homey-h4/homey-h4.component";
import {BulletListComponent} from "../../../components/bullet-list/bullet-list.component";
import {ParagraphsComponent} from "../../../components/paragraphs/paragraphs.component";

@Component({
  selector: 'homey-privacy-policy-page',
  imports: [
    PageTitleComponent,
    PageSubtitleComponent,
    PageTitleComponent,
    PageSubtitleComponent,
    TextPageComponent,
    HomeyH3Component,
    HomeyH4Component,
    BulletListComponent,
    ParagraphsComponent
  ],
  templateUrl: './privacy-policy-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrivacyPolicyPageComponent {

}
